export * from './entities.graphql'
